<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import 'element-ui/lib/theme-chalk/display.css';
	export default {
		name: 'app',
	}
</script>

<style lang="scss">
	@import '@/assets/scss/index.scss';
	@import url("assets/css/style.css");

	#app {
		// min-width:1350px;
		overflow: hidden;
		background: #f1f4f6;
		font-family: '微软雅黑';
	}
</style>
